import { createFileRoute } from '@tanstack/react-router';
import { LessonDetailPage } from '../../../../features/community-hub/components/lesson-detail-page';

/**
 * Community Hub - Lesson Detail Route
 * Path: /community-hub/lessons/:id
 *
 * Shows a lesson with content blocks (text, video, quiz)
 * User can track progress and mark lesson as complete
 */
export const Route = createFileRoute('/_protected/community-hub/lessons/$id')({
  component: LessonDetailPage,
});
